export const addExtraSpace=(params,trim=false)=>{
    if (typeof params === 'object' && !Array.isArray(params) && params !== null) {
        Object.keys(params).forEach((key) => {
            if(typeof params[key] === 'object')
                 addExtraSpace(params[key])
            else if(!trim)  (params[key] === "") ? params[key] = " " : params[key]
            else   (params[key] === " ") ? params[key]=params[key]?.trim() : params[key]
        })
    
    }
    return params
    
}

export const removeExtraSpace=(params)=>{
   return addExtraSpace(params,true)
}


export const typeList=[{id:1,value:"S",text:"Shipment Level"},{id:2,value:"I",text:"Invoice Level"}]

export const getMerchandisePartyTableList = (merchandiseMap, tableName) => {
    return Object.entries(merchandiseMap).reduce((prev, [_, value]) => {
        const tableItemList = value?.merchandiseParties?.[tableName] || []
        return [...prev, ...tableItemList]
    }, [])
}

export const geArrayByFieldName = (arr, fieldName) => {
    return arr?.map(itm => itm?.[fieldName]) || []
}